<template>
  <div class="market-ParkingCouponList-add">

    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <div class="base-config">
        <el-form-item  prop="mallId" label="选择商场" >
            <el-select v-model="form.mallId" placeholder="请选择商场" >
              <el-option v-for="item in mallData" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="券名称" prop="name">
          <el-input type="text" v-model="form.name" placeholder="请输入券名称"/>
        </el-form-item>
        <el-form-item label="图片" prop="imageUrl">
          <UploadImg name="imageUrl" @getUploadFile="getUploadFile" :uploadUrl="form.imageUrl" desc="建议：上传160*160jpg、png、jpeg图片"></UploadImg>
        </el-form-item>
        <el-form-item label="背景图" prop="backImgUrl">
          <UploadImg name="backImgUrl" :width="325" :height="165" @getUploadFile="getUploadFile" :uploadUrl="form.backImgUrl" desc="建议：上传750*330jpg、png、jpeg图片"></UploadImg>
        </el-form-item>
         <el-form-item label="抵扣类型" prop="mode">
          <el-radio-group v-model="form.mode">
            <el-radio label="FreeMoney">消费金额</el-radio>
            <el-radio label="FreeTime">停车时长</el-radio>
          </el-radio-group>
        </el-form-item>
         <el-form-item label="抵扣金额" prop="freeMoney" v-if="form.mode == 'FreeMoney'">
          <el-input type="text" v-model="form.freeMoney"  oninput="value=value.replace(/[^.\d]/g,'')" placeholder="请输入抵扣金额">
             <template slot="append">元</template>
          </el-input>
        </el-form-item>
         <el-form-item label="抵扣时长" prop="freeTime" v-if="form.mode == 'FreeTime'" >
          <el-input type="text" v-model="form.freeTime" class="freeTimeInputone" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入抵扣时长">
            <template slot="append">
            <el-select v-model="form.unit">
              <el-option label="分钟" value="Minute"></el-option>
              <el-option label="小时" value="Hour"></el-option>
            </el-select>
          </template>
          </el-input>
        </el-form-item>
        <el-form-item label="用券时间" prop="effectiveType">
          <el-radio-group v-model="form.effectiveType" :disabled="form.id?true:false">
            <el-radio label="Fixed">固定时间</el-radio>
            <el-radio label="CalendarDay">按自然日生效</el-radio>
            <el-radio label="IssueTime">按领取时间生效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.effectiveType == 'Fixed'" label="" prop="fixedTime">
          <el-date-picker
            v-model="form.fixedTime"
            type="datetimerange"
            range-separator=""
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
            :disabled="form.id?true:false"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="form.effectiveType == 'CalendarDay' || form.effectiveType == 'IssueTime'" label="" prop="period" :label-width="form.effectiveType == 'CalendarDay' ? '210px' : '350px'" >
          <el-input type="text" v-model="form.period" oninput="value=value.replace(/[^\d]/g,'')"  class="freeTimeInput" :disabled="form.id?true:false">
            <template v-if="form.effectiveType == 'CalendarDay'" slot="prepend">领/发当日起</template>
            <template v-if="form.effectiveType == 'IssueTime'" slot="prepend">领/发即时起</template>
            <template slot="append" v-if="form.effectiveType == 'CalendarDay'">天内可用</template>
            <template slot="append" v-if="form.effectiveType == 'IssueTime'">
              <el-select v-model="form.periodUnit">
              <el-option label="天" value="Day"></el-option>
              <el-option label="小时" value="Hour"></el-option>
            </el-select>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="使用须知" prop="remark">
          <el-input type="textarea" rows="6" v-model="form.remark" placeholder="请输入使用须知" maxlength="1000" show-word-limit />
        </el-form-item>
      </div>
    </el-form>

    <div class="footer">
      <el-button @click="onBack" class="mr20">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import {api_postParkingCouponAdd,api_getParkingCouponDatil,api_putParkingCouponUpadte} from '@/api/market'
import { api_getConfig, api_postFileUpload } from "@/api/common";

export default {
  name: "marketGiftCouponListAdd",
  components: {
    UploadImg,
  },
  data() {
    const checkImage = (rule, value, callback) => {
      if (!this.form.imageUrl) {
        callback(new Error('请上传图片'))
      }else {
        callback()
      }
    }
    const checkBackImg = (rule, value, callback) => {
      if (!this.form.backImgUrl) {
        callback(new Error('请上传背景图'))
      }else {
        callback()
      }
    }
    // 校验抵扣时长
    const checkFreeTime = (rule, value, callback) => {
      if(!value){
        callback(new Error('请输入抵扣时长'))
      }else if((value + '') && value <= 0){
        callback(new Error('请输入大于0的值'))
      }else{  
      callback()
      }
    }
    // 校验抵扣金额
    const checkFreeMoney = (rule, value, callback) => {
     let reg =  /^\d+(\.\d{1,2})?$/;
      if(!value){
        callback(new Error('请输入抵扣金额'))
      }else if((value + '') && value <= 0){
        callback(new Error('请输入大于0的值'))
      }else if(!reg.test(value)){  
        callback(new Error('请输入两位小数内的值'))
      }else{  
      callback()
      }
    }
    // 校验用券时间
    const checkFreePeriod = (rule, value, callback) => {
      console.log(!value&&this.form.effectiveType=='Fixed')
      if(!value&&this.form.effectiveType=='Fixed'){
        callback(new Error('请选择固定时间'))
      }
      if(!value&&this.form.effectiveType=='CalendarDay'){
        callback(new Error('请输入天数'))
      }
      if(!value&&this.form.effectiveType=='IssueTime'&&this.form.periodUnit=='Day'){
        callback(new Error('请输入天数'))
      }
      if(!value&&this.form.effectiveType=='IssueTime'&&this.form.periodUnit=='Hour'){
        callback(new Error('请输入小时'))
      }
      if((value + '') && value <= 0){
        callback(new Error('请输入大于0的值'))
      }else{  
      callback()
      }
    }
    return {
      isAdmin: false, // 是否是超级管理员
      submitLoading: false,
      form: {
        effectiveType: 'CalendarDay',
        periodUnit:"Day",
        mode:"FreeMoney",
        unit:'Hour',


      },
      rules: {
        mallId: [{required: true, message: '请选择商场'}],
        name: [{required: true, message: '请输入券名称'}],
        imageUrl: [{ validator: checkImage }],
        backImgUrl: [{ validator: checkBackImg }],
        effectiveType: [{required: true, message: '请选择用券时间'}],
        fixedTime: [{required: true, message: '请选择时间'}],
        period: [{validator: checkFreePeriod}],
        freeMoney:[{validator: checkFreeMoney}],
        freeTime:[{validator: checkFreeTime}],
      },

      mallData: [], // 获取商场数据
      shopTreeData: [], // 店铺级联框树形数据
      shopCascaderProps: {
        multiple: true,
        value: "id",
        label: "name",
        emitPath: false,
      }, // 店铺级联框配置项
      pickerOptions:{
        disabledDate (time) {
          return time.getTime() < Date.now()-1 * 24 * 3600 * 1000 // 限制选当前时间之后的时间
        }
      },
    };
  },
  created() {
    if(this.$route.query.id){
    this.getparkingCouponDetail()
   }
   
    this.isAdmin = JSON.parse(localStorage.getItem('USER_INFO')).admin
    this.getConfigData() // 获取商场、店铺级联框、折扣枚举数据
  },
  methods: {
    // 获取商场、店铺级联框数据
    async getConfigData() {
      let {mall, storeThreeLevel} = await api_getConfig(['mall', 'storeThreeLevel'])
      this.mallData = mall
      this.shopTreeData = storeThreeLevel
    },
    
     // 获取券详情
    async getparkingCouponDetail() {
      let res = await api_getParkingCouponDatil({id: this.$route.query.id})
      this.form = {
        ...res,
        id:this.$route.query.id?Number(this.$route.query.id):undefined,
        fixedTime:res.startTime?[res.startTime,res.endTime]:[],
        unit:res.mode=="FreeTime"?res.unit:'Hour'
      }
    },
    formatNumber(num) {
    if (Number.isInteger(num)) {
    // 如果是整数，直接返回整数部分
    return Number(num).toString();
    } else {
    // 如果是小数，保留两位小数
    return Number(num).toFixed(2);
    }
    },
    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let params = {
              ...this.form,
              supplier: "Happay",
            }
            // 上传头图
            if (this.form.imageUrl && this.form.imageUrl.size) {
              const { key } = await api_postFileUpload(this.form.imageUrl, 'LotCoupon')
              params.imageKey = key
            }
            // 上传背景图
            if (this.form.backImgUrl && this.form.backImgUrl.size) {
              const { key } = await api_postFileUpload(this.form.backImgUrl, 'LotCoupon')
              params.backImgKey = key
            }
            // 处理用券时间---固定时间的时间值
            if (this.form.effectiveType == 'Fixed') {
              params.startTime = this.form.fixedTime ? this.$moment(this.form.fixedTime[0]).valueOf() : null // 券有效期-开始
              params.endTime = this.form.fixedTime ? this.$moment(this.form.fixedTime[1]).valueOf() : null // 券有效期-结束
            }
            if(params.mode == "FreeMoney"){
              params.freeMoney = this.formatNumber(params.freeMoney)
              delete params.freeTime
              delete params.unit
            }
            if(params.mode == "FreeTime"){
              delete params.freeMoney
            }
            delete params.fixedTime
            
            console.log('params: ', params);
            // return

            const res = this.$route.query.id?await api_putParkingCouponUpadte(params):await api_postParkingCouponAdd(params)
            console.log('res: ', res);
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },

    getUploadFile (file, name) {
      this.form[name] = file
    },

    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
  watch: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.market-ParkingCouponList-add {
  padding: 35px 20px 0 20px;
  padding-bottom: 100px;
  box-sizing: border-box;

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .base-config {
    margin-top: 20px;
    padding-bottom: 30px;
    .store-select {
      .mall-select-box {
        margin-left: 100px;
        margin-top: -20px;
      }
      .store-select-box {
        // margin-left: 240px;
        margin-left: 210px;
        margin-top: -20px;
      }
    }
  }

  ::v-deep {
    .el-radio-group {
      .el-radio-button__inner {
        height: 34px;
        padding: 0;
        line-height: 34px;
        margin-right: 1px;
        width: 100px;
        border: 0;
      }

      .el-radio-button:first-child {
        .el-radio-button__inner {
          border-radius: 2px 0px 0 0;
        }
      }

      .el-radio-button:last-child {
        .el-radio-button__inner {
          border-radius: 0 2px 0 0;
        }
      }
    }

    
    .el-input,
    .el-textarea,
    .el-select {
      width: 350px;
    }
    .freeTimeInput {
      .el-input{
      width: 100px  
    }
     .el-select{
      width: 100px 
    }
     .el-input__inner {
      width: 150px 
    }
    }
    .freeTimeInputone {
      .el-input{
      width: 100px ;  
    }
     .el-select{
      width: 100px ;  
    }
     .el-input__inner {
      width: 250px ;  
    }
    }
    .el-range-editor.el-input__inner {
      width: 350px;
      background: #F2F3F5;
      border: 0;

      input {
        background: #F2F3F5;
        border: 0;
      }
    }

    .el-range-editor.el-input__inner.is-active {
      width: 350px;
      background: #fff;
      border: 1px solid #05C8AF;

      input {
        background: #fff;
        border: 0;
      }
    }

    .desc {
      color: #999;
      font-size: 12px;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    z-index: 999;
  }
}
</style>
